

export class UserLicenseDetailsWithOutStatusOutput implements IUserLicenseDetailsWithOutStatusOutput {
    /** The auto-generated id of the user license details master */
    user_license_id!: number;
    /** The user name with 255 character */
    user_name!: string;

    constructor(data?: IUserLicenseDetailsWithOutStatusOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user_license_id = _data["user_license_id"];
            this.user_name = _data["user_name"];
        }
    }

    static fromJS(data: any): UserLicenseDetailsWithOutStatusOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UserLicenseDetailsWithOutStatusOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user_license_id"] = this.user_license_id;
        data["user_name"] = this.user_name;
        return data; 
    }
}

export interface IUserLicenseDetailsWithOutStatusOutput {
    /** The auto-generated id of the user license details master */
    user_license_id: number;
    /** The user name with 255 character */
    user_name: string;
}

